"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextField;
var _react = _interopRequireDefault(require("react"));
var _reactHookForm = require("react-hook-form");
var _reactNumberFormat = require("react-number-format");
var _enums = require("./enums");
var S = _interopRequireWildcard(require("./styles"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function TextField({
  control,
  defaultValue,
  disabled = false,
  error: defaultError,
  label,
  labelStyle,
  name,
  omitFromSubmission = false,
  required = false,
  rules,
  shouldUnregister = false,
  type = 'text',
  placeholder,
  format,
  mask,
  patternChar,
  ...numericFormatProps
}) {
  const {
    field,
    fieldState: {
      error
    }
  } = (0, _reactHookForm.useController)({
    name,
    control,
    rules,
    shouldUnregister,
    defaultValue,
    disabled: omitFromSubmission
  });
  const errorMessage = error?.message || defaultError;
  const hasFormat = format?.length;
  const patternFormat = _enums.FormatsEnum[format] || format;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(S.Label, {
    $disabled: disabled || omitFromSubmission,
    $error: !!errorMessage,
    htmlFor: name,
    style: labelStyle
  }, label, label && required && ' *', hasFormat && /*#__PURE__*/_react.default.createElement(_reactNumberFormat.PatternFormat, _extends({}, field, {
    id: name,
    inputMode: "text",
    placeholder: placeholder,
    customInput: S.TextField,
    format: patternFormat,
    mask: mask,
    patternChar: patternChar
  })), type === 'number' && !hasFormat && /*#__PURE__*/_react.default.createElement(_reactNumberFormat.NumericFormat, _extends({}, numericFormatProps, field, {
    id: name,
    placeholder: placeholder,
    customInput: S.TextField
  })), type !== 'number' && !hasFormat && /*#__PURE__*/_react.default.createElement(S.TextField, _extends({}, field, {
    id: name,
    type: type,
    placeholder: placeholder
  }))), /*#__PURE__*/_react.default.createElement(S.Error, null, !!errorMessage && errorMessage));
}